import React, { useEffect } from "react";

// Importing Packages
import { v4 as uuidv4 } from "uuid";

//Importing Libraries
var Highcharts = require("highcharts");

function HorColumnChart(props) {
  let id = generateRandomGuid();
  function generateRandomGuid() {
    return uuidv4();
  }

  useEffect(() => {
    function renderChart(id,colorset,backcolor,label) {
      Highcharts.chart(`hcc-${id}`, {
        chart: {
          type: "bar",
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
          backgroundColor: backcolor,
     
          height: 200,
        },

        credits: {
          enabled: false,
        },

        exporting: {
          enabled: false,
        },

        title: {
          text: null,
        },

        xAxis: {
          categories: ["2020", "2019", "2018"],
        
          title: {
            text: "Year",
            // color: ''
            style: {
              color: "#6E7D87",
            },
          },

          labels: {
            style: {
              /* fontFamily: 'Roboto', */
              fontWeight: "bold",
              color: label,
            },
          },
        },
        yAxis: {
          min: 0,
          gridLineDashStyle: "dash",
          title: {
            text: "Number Of Projects",
            align: "middle",
            style: {
              color: "#6E7D87",
            },
          },

          labels: {
            overflow: "justify",
          },
        },
        tooltip: {
          valueSuffix: null,
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: false,
            },
            // series: {
            //   borderRadius: 5,
            //   pointWidth: 13,
            //   pointInterval: 1, // one day
            // },
          },
        },
        legend: {
          enabled: false,
          layout: "vertical",
          align: "right",
          verticalAlign: "top",
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
          shadow: true,
        },

        series: [
          {
            name: "Number Of Projects",
            borderWidth: 7,
            borderColor: colorset,
            borderRadius: 8,
            color: "#24A0D9",
            paddingBottom: 0,
            pointWidth: 13,
            data: [63, 45, 29],
          },
        ],
      });
    }
    renderChart(id,props.colorset,props.backcolor,props.label);
  }, [id,props.colorset,props.backcolor,props.label]);
  return <div id={`hcc-${id}`}></div>;
}

export default HorColumnChart;
